
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { jwtDecode } from 'jwt-decode';
import './Header.css';

interface DecodedToken {
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name': string;
}

interface HeaderProps {
  onToggleSidebar: () => void;
}

const Header = ({ onToggleSidebar }: HeaderProps) => {
  const { token, logout } = useAuth();
  const [username, setUsername] = useState('');

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode<DecodedToken>(token);
      setUsername(decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']);
    }
  }, [token]);

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="header">
      <div className="header-left">
        <div className="menu-icon bi bi-list" onClick={onToggleSidebar}></div>
      </div>
      <div className="header-right">
        <div className="user-info-dropdown">
          <div className="dropdown">
            <a
              className="dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
            >
              <span className="user-icon">
               <i className="bi bi-person-circle fs-1 black-color" style={{ fontSize: '38px' }}></i>

              </span>
              <span className="user-name">{username}</span>
            </a>
            <div
              className="dropdown-menu dropdown-menu-right dropdown-menu-icon-list"
            >
                          <Link className="dropdown-item" to="/profile">
                              <i className="dw dw-user1"></i> Profile
                          </Link>
              <a
                className="dropdown-item"
                href="#"
                onClick={e => {
                  e.preventDefault();
                  handleLogout();
                }}
              >
                <i className="dw dw-logout"></i> Log Out
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
